<template>
  <div class='organization-linked-domains-list'>
    <div class='domain-row' v-for='(asset, index) in itemsForDisplay' :key='index'>
      <div class='domain-row__content'>
        <div class='domain-type'>
          <v-icon> {{ typeIcon(asset) }} </v-icon>
        </div>
        <div class='domain-name'>
          {{ asset }}
          <div class='default' v-if='isDefaultDomain(asset)'> {{ $t('default') }} </div>
        </div>
        <custom-tooltip class='unlink' placement="right" popper-class="light-tooltip" v-if='enableUnlink'>
          <div slot='buttonContent'>
            <span
              class="delete-icon material-icons"
              :class="{ 'delete-icon--disabled': isSupplyChain }"
              @click="!isSupplyChain && unlinkDomain(asset)"
            >
                highlight_off
            </span>
          </div>
          <div slot="content">
            <slot name="tooltip">
              {{ isSupplyChain ? $t('tprm.domain.unlink.disabled.tooltip') : $t('unlink.domain.from.organization.tooltip') }}
            </slot>
          </div>
        </custom-tooltip>
      </div>
      <div class='domain-row__divider' v-if='index !== items.length - 1'>
        <v-divider/>
      </div>
    </div>
    <div class='buttons' v-if='items.length > 3'>
      <span class='buttons__show-all' @click='showAllDomains'> {{showAllToggleCaption}} </span>
      <span class="buttons__show-more" @click='showMoreDomains'> {{showMoreToggleCaption}} </span>
    </div>
  </div>
</template>

<script>
import CustomTooltip from '@/components/common/CustomTooltip.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'OrganizationLinkedDomainsList',
  components: { CustomTooltip },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    enableUnlink: {
      type: Boolean,
      required: true,
      default: false,
    },
    organization: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      isShowAll: false,
      showMore: 1,
    };
  },
  computed: {
    ...mapGetters(['configurationDomains']),
    isSupplyChain() {
      return !!this.organization?.isSupplyChain;
    },
    showAllToggleCaption() {
      return this.isShowAll || this.showMore * 3 >= this.items.length ? this.$t('services.tab.details.hide') : this.$t('services.tab.details.show.all');
    },
    showMoreToggleCaption() {
      return this.isShowAll || this.showMore * 3 >= this.items.length ? this.$t('services.tab.details.show.less') : this.$t('services.tab.details.show.more');
    },
    itemsForDisplay() {
      let formattedItems = [...this.items].sort((a, b) => {
        if (a === this.organization.domain) {
          return -1;
        }
        if (b === this.organization.domain) {
          return 1;
        }
        return a > b ? 1 : -1;
      });
      if (!this.isShowAll) {
        if (!(3 * this.showMore > formattedItems.length)) {
          formattedItems = formattedItems.slice(0, 3 * this.showMore);
        }
      }
      return formattedItems;
    },
  },
  methods: {
    isDefaultDomain(domain) {
      return this.organization.domain === domain;
    },
    typeIcon(asset) {
      return this.configurationDomains.find(item => item.configData === asset) ? 'language' : 'cloud';
    },
    showAllDomains() {
      this.isShowAll = !this.isShowAll;
      if (this.isShowAll) {
        this.showMore = Math.ceil(this.items.length / 3);
      } else {
        this.showMore = 1;
      }
    },
    showMoreDomains() {
      if (!(this.showMore * 3 >= this.items.length)) {
        this.showMore += 1;
        this.isShowAll = this.showMore * 3 >= this.items.length;
      } else if (this.showMore * 3 >= this.items.length) {
        this.isShowAll = false;
        this.showMore -= 1;
      }
    },
    unlinkDomain(asset) {
      this.$emit('unlinkDomain', { asset });
    },
  },
};
</script>

<style lang='scss' scoped>
@import "src/assets/styles/variables";
.organization-linked-domains-list {
  display: flex;
  flex-direction: column;
  margin-top:  1%;
  .domain-row {
    display: flex;
    flex-direction: column;
    min-height: 75px;
    &__content {
      margin-top: 1%;
      margin-bottom: 1%;
      display: flex;
      align-items: center;
      .domain-type {
        margin-right: 1%;
      }
      .domain-name {
        width: 16%;
        .default {
          font-size: 10px;
          margin-left: 2px;
          color: $input-label-color;
        }
      }
      .unlink {
        margin-top: 20px;
        &__tooltip {
          background-color: transparent;
        }
        .delete-icon {
          color: $error-color;
          cursor: pointer;
          font-size: 16px;
          margin-left: 5px;
          margin-bottom: 5px;
          font-weight: bolder;
          &--disabled {
            color: $input-label-color;
            cursor: not-allowed;
            opacity: 0.5;
          }
        }
      }
    }
    &__divider {
      width: 20%;
    }
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: left;
    margin-top: 1%;
    margin-bottom: 1%;
    &__show-all, &__show-more {
      color: $action-button-text-color;
      font-family: $default-application-font-regular;
      font-size: 14px;
      letter-spacing: 0;
      padding: 0 30px;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
